/* 20/05/2024 - Khang - Ignore for separate deployment */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

import { ViewLayout, AdvanceStack, OtherLayout } from './components';
import { RibbonBar, RibbonDivider } from 'common/components';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import ProductHierarchy from './components/controls/product-full/ProductHierarchy';
import HistorySection from './components/sections/product/HistorySection';
import ProductDetailView from './components/controls/product-full/ProductDetailView';
import DetailQaSpec from './components/controls/product-full/DetailQaSpec';
import QASpecAssignSupplier from './components/controls/product-full/QASpecAssignSupplier';
import QaEvaluationForm from './components/controls/product-full/QaEvaluationForm';
import ProductPackaging from './components/controls/product-full/ProductPackaging';

import HierarchyActions from './components/controls/product-full/HierarchyActions';
import ProductFullAction from './components/controls/product-full/ProductFullAction';
import * as actionsGlobal from '@redux/global/actions';

import { useGetProductFullView } from 'hooks';
import { useOpenReportingResult } from 'hooks/useOpenReportingResult';
import { useCheckPermissionOR } from 'hooks/useCheckPermissions';
import { useFolderByLevel } from 'hooks/useFolderByLevel';
import { useInitialWorkflowQaSpec } from 'hooks/useInitialWorkflowQaSpec';
import { useCheckCertificatePermission } from './components/sections/product/components/certificate-actions/hook';
import CertificateActions from './components/sections/product/CertificateActions';
import QaSpecHistoryIcon from 'assets/traceable-comment/QaSpecHistoryIcon';
import RibbonButton from 'common/components/button/RibbonButton';
import { useGetQaSpecHistory } from './components/controls/product-full/hooks/useGetQaSpecHistory';

// import useCheckIXOneCapture from 'hooks/useCheckIXOneCapture';
import { allowMemberUseEvalForm } from 'utils/checkIsOwner';
import DetailsQASpecHistory from './components/controls/product-full/DetailsQASpecHistory';

const ProductFullViewRibbon = ({
  isHaveAddOpenItem = true,
  productId,
  shouldShowPackaging = true,
}) => {
  const dispatch = useDispatch();
  const { keepSetting, keepResultGridPagination } = useOpenReportingResult();
  const checkPermission = useCheckPermissionOR();

  const { invalidateQaSpecHistory } = useGetQaSpecHistory(productId, false);
  const [isHistoryModalVisible, setIsHistoryModalVisible] = useState(false);

  const showHistoryModal = () => {
    invalidateQaSpecHistory();
    setIsHistoryModalVisible(true);
  };
  const closeHistoryModal = () => {
    setIsHistoryModalVisible(false);
  };

  const hasQaSpecPermission = checkPermission([
    [ABILITY_ACTION.VIEW, ABILITY_SUBJECT.QA_SPECIFICATION],
  ]);

  const hasQaSpecPackingPermission = checkPermission([
    [ABILITY_ACTION.VIEW, ABILITY_SUBJECT.QA_SPECIFICATION],
    [ABILITY_ACTION.EDIT, ABILITY_SUBJECT.QA_SPECIFICATION],
  ]);

  const hasEvaluationFormPermission = checkPermission([
    [ABILITY_ACTION.VIEW, ABILITY_SUBJECT.EVALUATION_FORM],
  ]);

  const { productFull } = useGetProductFullView({ productId });

  const { checkCertificatesPermission } = useCheckCertificatePermission();

  const { shouldKeepFolderBreadcrumb, keepFolderBreadcrumb } =
    useFolderByLevel();

  const closeDetailCallback = () => {
    keepSetting();
    keepResultGridPagination();

    //* keep folder breadcrumb when close folder item detail
    shouldKeepFolderBreadcrumb && keepFolderBreadcrumb(true);
  };

  //* Reset not go back to members route.
  //* In case user go form member full view -> company's product.
  useEffect(() => {
    dispatch(actionsGlobal.resetProdAssetsToMember());
  }, [dispatch]);

  const { checkInitialWorkflowQaSpecRibbon } = useInitialWorkflowQaSpec();
  const isInitialWorkflowQaSpecRibbon = checkInitialWorkflowQaSpecRibbon();
  const hasCertificatePermission = checkCertificatesPermission();

  return (
    <>
      <RibbonBar>
        <ManageSharingSection />
        <DetailSection />
        <ViewLayout disabled={true} />
        <RibbonDivider />
        <ProductDetailView productId={productId} />

        <ProductFullAction productFull={productFull} productId={productId} />

        <RibbonDivider />
        {shouldShowPackaging && hasQaSpecPackingPermission ? (
          <ProductPackaging productFull={productFull} />
        ) : null}
        <ProductHierarchy productId={productId} />
        {/* {isAllowEditProduct ? <Subscription productId={productId} /> : null} */}

        {hasCertificatePermission && (
          <>
            <RibbonDivider />
            <CertificateActions isFullView />
          </>
        )}

        <RibbonDivider />

        <HierarchyActions productId={productId} />

        <HistorySection />

        {hasQaSpecPermission && <DetailQaSpec productData={productFull} />}

        {isInitialWorkflowQaSpecRibbon && (
          <>
            <QASpecAssignSupplier productData={productFull} />
            <RibbonDivider />
          </>
        )}

        {hasEvaluationFormPermission &&
          allowMemberUseEvalForm(productFull?.ownerId) && (
            <>
              <QaEvaluationForm productData={productFull} />
              <RibbonDivider />
            </>
          )}

        {hasQaSpecPermission && (
          <>
            <RibbonButton
              icon={<QaSpecHistoryIcon />}
              label='QA Spec Status History'
              onClick={() => {
                showHistoryModal();
              }}
            />
            <RibbonDivider />
          </>
        )}

        <AdvanceStack isDisabled={true} />

        <OtherLayout
          ribbonSide='right'
          ribbonType='products'
          isHaveAddOpenItem={isHaveAddOpenItem}
          closeDetailCallback={closeDetailCallback}
        />
      </RibbonBar>
      <DetailsQASpecHistory
        visible={isHistoryModalVisible}
        onClose={closeHistoryModal}
        productId={productId}
      />
    </>
  );
};

export default ProductFullViewRibbon;
